module.exports = __webpack_public_path__ + "img/hero.5af9c5be.svg";